import axios from "axios";

import { TOKEN, REFRESH_TOKEN } from "../../constants";
import { cookieValue } from "../helper";
import { endLoading, startLoading } from "../../store/actions/loadingActions";
import { store } from "../../store/store";

const vediApi = axios.create({
  baseURL: process.env.REACT_APP_URL_WS,
  headers: {
    "Content-Type": "application/json",
  },
});

vediApi.interceptors.request.use(
  (config) => {
    const token = cookieValue(TOKEN);
    if (token) {
      config.headers["--Token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

vediApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    store.dispatch(startLoading());
    console.error("por error", error);
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      return refreshCidi(originalRequest);
    } else {
      store.dispatch(endLoading());
      return Promise.reject(error);
    }
  }
);

const refreshCidi = async (originalRequest) => {
  try {
    const resLogin = await axios.get(
      `${process.env.REACT_APP_URL_WS}/v1/usuario/RefreshToken`,
      {
        headers: {
          "--Token": cookieValue(REFRESH_TOKEN),
          "--Key": "xyg61jmCMxVYBX6TRuyxEQZXK",
        },
      }
    );

    if (resLogin.status === 200 && resLogin.data && resLogin.data.return) {
      originalRequest._retry = false;
      const { token, refreshToken } = resLogin.data.return;
      document.cookie = `${TOKEN}=${token}; path=/`;
      document.cookie = `${REFRESH_TOKEN}=${refreshToken}; path=/`;
      vediApi.defaults.headers.common["--Token"] = token;
      store.dispatch(endLoading());
      return vediApi(originalRequest);
    } else if (resLogin.status === 200 && !resLogin.data.ok) {
      window.open(process.env.REACT_APP_URL_LANDING, "_self");
    }
  } catch (error) {
    window.open(process.env.REACT_APP_URL_LANDING, "_self");
    throw error;
  }
};

export default vediApi;
